<script>
  //// imports
  import { SkeletonText } from "carbon-components-svelte";
  import { Button } from "paxray-components-svelte"
  import AccordionPagination from "lib/components/accordionPagination.svelte";
  import Badge from "./Badge.svelte";
  import { EDIT_ICON, MERGE_ICON, SPLIT_ICON } from '@utils/icons.js';

  export let processes = [];
  export let selectedProcesses = [];
  export let editProcess;
  export let mergeProcesses;
  export let onlyOneProcess = false;
  export let loading = false;
  export let selectedHasNames = false;

  let pageSize = 5; // default value for number of apps shown
  let currentPage = 1;

  let displayedProcesses = [];

  let searchTerm = "";

  $: icon =
    selectedProcesses.length === 1
      ? SPLIT_ICON
      : selectedProcesses.length > 1
        ? MERGE_ICON
        : null;

  $: updateDisplay(currentPage, searchTerm, processes);

  $: {
    if (displayedProcesses.length > 0) {
      updateDisplay(currentPage, searchTerm, processes);
    }
  }

  function selectProcess(clickedprocess) {
    clickedprocess = !selectedHasNames ? clickedprocess.id : clickedprocess;
    if (onlyOneProcess) {
      selectedProcesses = [clickedprocess];
      displayedProcesses = processes;
    } else if (selectedProcesses.includes(clickedprocess)) {
      selectedProcesses = selectedProcesses.filter(
        (process) => process !== clickedprocess
      );
    } else {
      selectedProcesses.push(clickedprocess);
      selectedProcesses = selectedProcesses;
      if (!clickedprocess.id) {
        displayedProcesses = displayedProcesses.filter(
          (process) => process.id !== clickedprocess
        );
      } else {
        displayedProcesses = displayedProcesses.filter(
          (process) => process.id !== clickedprocess.id
        );
      }
    }
  }

  let filteredProcesses = [];

  function deselectProcess(clickedprocess) {
    clickedprocess = clickedprocess.id ? clickedprocess.id : clickedprocess;
    if (selectedHasNames) {
      selectedProcesses = selectedProcesses.filter(
        (process) => process.id !== clickedprocess
      );
    } else {
      selectedProcesses = selectedProcesses.filter(
        (process) => process !== clickedprocess
      );
    }
    const process = processes.find((process) => process.id === clickedprocess);

    displayedProcesses = [...displayedProcesses, process];
  }

  function updateDisplay(currentPage, search, processes) {
    if (search) {
      filteredProcesses = processes.filter((process) =>
        process.name.toLowerCase().includes(search.toLowerCase())
      );
    } else {
      if (onlyOneProcess) {
        filteredProcesses = processes;
      } else {
        filteredProcesses = processes.filter((process) =>
          selectedHasNames
            ? !selectedProcesses.find(
                (selectedProcess) => selectedProcess.id === process.id
              )
            : !selectedProcesses.includes(process.id)
        );
      }
    }
    while (filteredProcesses.length <= (currentPage - 1) * pageSize) {
      currentPage--;
    }

    let tempDisplayed = filteredProcesses;
    if (!onlyOneProcess) {
      tempDisplayed = filteredProcesses.filter((process) =>
        selectedHasNames
          ? !selectedProcesses.find(
              (selectedProcess) => selectedProcess.id === process.id
            )
          : !selectedProcesses.includes(process.id)
      );
    }

    displayedProcesses = tempDisplayed.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );

    if (
      displayedProcesses.length < pageSize &&
      tempDisplayed.length > pageSize
    ) {
      let additionalProcesses = tempDisplayed
        .slice(currentPage * pageSize)
        .slice(0, pageSize - displayedProcesses.length);
      displayedProcesses = [...displayedProcesses, ...additionalProcesses];
    }
  }

  function getProcessName(processId) {
    return processes.find((process) => process.id === processId)?.name || "";
  }
</script>

{#if !onlyOneProcess}
  <div
    class={`budge ${selectedProcesses.length === 1 ? "flex" : selectedProcesses.length > 0 ? "process-selected" : ""}`}
  >
    {#if processes.length > 0 || selectedHasNames}
      {#each selectedProcesses as process}
        <Badge
          text={process.name ? process.name : getProcessName(process)}
          handleClick={() => deselectProcess(process.id ? process.id : process)}
          clickable
          disable={!processes.some((processList) =>
            process.id
              ? processList.id === process.id
              : processList.id === process
          )}
        />
      {/each}
    {/if}
    {#if selectedProcesses.length === 1 && processes.some((processList) => processList.id === selectedProcesses[0].id)}
      <div class="button-container">
        <Button
          kind="secondary"
          size="small"
          icon={EDIT_ICON}
          on:click={() => {
            if (selectedHasNames)
              editProcess(selectedProcesses[0].id, selectedProcesses[0].name);
            else {
              const process = processes.find(
                (process) => process.id === selectedProcesses[0]
              );
              editProcess(process.id, process.name);
            }
          }}
        />
      </div>
    {/if}
  </div>
{/if}
<div class="app_selection_wrapper">
  <div class="top_bar">
    <div class="search_wrapper">
      <div
        class="search"
        class:disabled={!displayedProcesses || displayedProcesses.length === 0}
      >
        <div class="searchicon">
          <svg
            height="100%"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.1466 24L14.8751 14.4151C14.077 15.0963 13.1462 15.6125 12.0828 15.9637C11.0193 16.3149 9.96862 16.4906 8.9306 16.4906C6.45541 16.4906 4.36059 15.6939 2.64614 14.1005C0.931688 12.5071 0.0744629 10.5574 0.0744629 8.25144C0.0744629 5.94545 0.928225 3.99371 2.63575 2.39623C4.3433 0.798742 6.42958 0 8.89461 0C11.3596 0 13.4579 0.797296 15.1894 2.39189C16.921 3.98645 17.7867 5.93492 17.7867 8.23728C17.7867 9.26149 17.5845 10.2704 17.1802 11.2642C16.7758 12.2579 16.2231 13.1069 15.5222 13.8113L25.7937 23.3585L25.1466 24ZM8.9306 15.6604C11.1705 15.6604 13.0582 14.9497 14.5938 13.5283C16.1293 12.1069 16.8971 10.3459 16.8971 8.24528C16.8971 6.14465 16.1293 4.38365 14.5938 2.96226C13.0582 1.54088 11.1705 0.830189 8.9306 0.830189C6.69074 0.830189 4.80302 1.54088 3.26744 2.96226C1.7319 4.38365 0.964121 6.14465 0.964121 8.24528C0.964121 10.3459 1.7319 12.1069 3.26744 13.5283C4.80302 14.9497 6.69074 15.6604 8.9306 15.6604Z"
              fill="#1C1C20"
            />
          </svg>
        </div>
        <input
          type="text"
          bind:value={searchTerm}
          disabled={!displayedProcesses || displayedProcesses.length === 0}
          placeholder="Search for Process"
        />
      </div>
    </div>
    <div class="new_activity">
      {#if selectedProcesses.length > 0}
        <Button
          iconDescription="Merge Processes"
          {icon}
          on:click={mergeProcesses}
          disabled={selectedProcesses.length < 1}
        />
      {/if}
    </div>
  </div>
  <div class="bar_wrapper">
    {#each displayedProcesses as process}
      <!-- svelte-ignore missing-declaration -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="appinfo_wrapper">
        {#if !loading || selectedProcesses.length === 0}
          <div
            class="app_name {selectedProcesses.includes(process.id) ||
            selectedProcesses.some(
              (selectedProcess) => selectedProcess.id === process.id
            )
              ? 'selected'
              : ''}"
            on:click={() => {
              selectProcess({ id: process.id, name: process.name });
            }}
          >
            {process.name}
          </div>
        {:else}
          <div class="app_loading">
            <SkeletonText />
          </div>
        {/if}

        <div>
          <Button
            kind="secondary"
            icon={EDIT_ICON}
            disabled={loading && selectedProcesses.length !== 0}
            on:click={() => {
              editProcess(process.id, process.name);
            }}
          />
        </div>
      </div>
    {/each}
  </div>

  <AccordionPagination
    item="Processes"
    total={filteredProcesses.length}
    bind:currentpage={currentPage}
    itemsPerPage={pageSize}
    disablePrev={currentPage === 1}
    disableNext={currentPage >= Math.ceil(filteredProcesses.length / pageSize)}
  />
</div>

<style>
  .appinfo_wrapper {
    height: 3rem;
    width: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.5rem;
  }

  .app_name.selected {
    border-color: var(--pax-black);
  }

  .app_name:hover {
    border-color: var(--pax-black);
  }

  .app_name,
  .app_loading {
    flex-shrink: 1;
    height: 3rem;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    cursor: pointer;
    border-radius: 0.5rem;
    background-color: var(--pax-smoke);
    border: 1px solid;
    border-color: var(--pax-smoke);
    color: var(--pax-black);
  }

  .app_name {
    padding-left: 1rem;
  }

  .bar_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 1rem;
  }

  .app_selection_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .top_bar {
    display: flex;
    gap: 0.5rem;
  }

  .search_wrapper {
    display: flex;
    gap: 0.5rem;
    flex-grow: 1;
    width: 100%;
    flex-shrink: 1;
    flex-grow: 1;
  }

  .search {
    border: 1px solid #1c1c20;
    border-radius: 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
  }

  .searchicon {
    height: 1.5rem;
  }

  input {
    border: none;
    padding-left: 1rem;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input:focus,
  input:active {
    outline: none;
  }

  .budge {
    margin-top: -12px;
    margin-bottom: 12px;
    padding-bottom: 4px;
  }

  .flex {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #c9c9c9;
  }

  .process-selected {
    border-bottom: 1px solid #c9c9c9;
  }

  .button-container {
    margin-left: auto;
  }

  .search.disabled,
  input:disabled,
  .search.disabled .searchicon {
    background-color: var(--pax-white);
    opacity: 0.5;
    cursor: not-allowed;
  }

  .search.disabled {
    border: 1px solid var(--pax-grey);
  }
</style>
